<template>
  <div class="Create alignment">
    <template>
      <v-flex xs12 sm12>
        <h3 v-if="edit" class="styleHeader">
          {{
            $t("pages.UserCustomer.Create.MappaturaUtenteCommittenteModifica")
          }}
        </h3>
        <h3 v-else class="styleHeader">
          {{
            $t("pages.UserCustomer.Create.MappaturaUtenteCommittenteAggiungi")
          }}
        </h3>
        <v-card class="styleDataTable">
          <form>
            <v-layout>
              <v-select
                v-model="customer"
                :label="$t('pages.UserCustomer.Create.Committente')"
                required
                :items="customers"
                :error-messages="customersError"
                autocomplete
                item-text="name"
                item-value="id"
                @blur="$v.customer.$touch()"
              ></v-select>
              <v-select
                v-model="user"
                :label="$t('pages.UserCustomer.Create.Utente')"
                required
                :disabled="edit"
                :items="users"
                :error-messages="usersErrors"
                autocomplete
                item-text="formattedName"
                item-value="Id"
                @blur="$v.user.$touch()"
              ></v-select>
            </v-layout>
          </form>
        </v-card>
      </v-flex>
      <v-btn
        class="white--text styleButtonTop styleAlignementSaveButton"
        @click="creatingMapping()"
        color="#279947"
      >
        <v-icon left>check_circle</v-icon>
        {{ $t("pages.UserCustomer.Create.Salva") }}
      </v-btn>
      <v-btn class="styleButtonTop" @click="back()">
        <v-icon left>remove_circle</v-icon>
        {{ $t("pages.UserCustomer.Create.Annulla") }}
      </v-btn>

      <v-alert :value="errorAlert" type="error" transition="scale-transition">
        {{ errorMessage }}
      </v-alert>
    </template>
  </div>
</template>

<script>
//:disabled="edit"

import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import usersApi from "../../apiSmartLogistics/usersApi.js";
import customersApi from "../../apiSmartLogistics/customersApi.js";
import userscustomersApi from "../../apiSmartLogistics/userscustomersApi.js";
import debounce from "debounce";
import router from "@/router/index.js";

import { Trans } from "@/plugins/Translation";
export default {
  mixins: [validationMixin],

  validations: {
    user: { required, maxLength: maxLength(50) },
    customer: { required, maxLength: maxLength(50) }
  },

  data: () => ({
    Id: 0,
    user: "",
    users: [],
    customer: "",
    customers: [],
    errorAlert: false,
    errorMessage: ""
  }),

  computed: {
    edit() {
      return this.$route.params.Id > 0;
    },

    customersError() {
      const errors = [];
      if (!this.$v.customer.$dirty) return errors;
      !this.$v.customer.required &&
        errors.push(this.currentLanguage.t("Validations.CommittenteRichiesto"));
      return errors;
    },
    usersErrors() {
      const errors = [];
      if (!this.$v.user.$dirty) return errors;
      !this.$v.user.required &&
        errors.push(this.currentLanguage.t("Validations.UtenteRichiesto"));
      return errors;
    },
    currentLanguage() {
      return Trans.i18n;
    }
  },

  created() {
    const Id = this.$route.params.Id;

    if (Id) {
      userscustomersApi.GetViewUserCustomer(Id).then(response => {
        this.customer = response.data.customerId;
        this.user = response.data.userId;
      });
    }

    customersApi.GetCustomers().then(response => {
      this.customers = response.data;
    });

    usersApi.GetUsers().then(response => {
      this.users = response.data;
    });
  },

  methods: {
    loadCustomers: debounce(function(event) {
      if (event.target.value.lenght > 1) {
        let searchCustomers = {
          Id: "",
          Name: event.target.value,
          Stock: "",
          CodiceSocieta: "",
          CodiceAS: ""
        };
        customersApi.GetCustomers(searchCustomers).then(({ data }) => {
          this.customer = data;
        });
      }
    }, 200),

    loadUsers: debounce(function(event) {
      usersApi.SearchUsers(event.target.value).then(({ data }) => {
        this.user = data;
      });
    }, 200),

    creatingMapping() {
      this.$v.$touch();
      const Id = this.$route.params.Id;

      if (this.$v.user.error || this.$v.customer.error) {
        return;
      }

      let userCustomer = {
        Id: Id,
        UserId: this.user,
        CustomerId: this.customer
      };

      if (Id) {
        userscustomersApi
          .UpdateViewUsersCustomers(userCustomer)
          .then(() => {
            router.push({ name: "UsersCustomersIndex" });
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      } else {
        userscustomersApi
          .InsertViewUsersCustomers(userCustomer)
          .then(() => {
            router.push({ name: "UsersCustomersIndex" });
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      }
    },

    back() {
      router.push({ name: "UsersCustomersIndex" });
    },

    clear() {
      if (this.$route.params.Id) {
        this.$v.$reset();
        this.customer = "";
      } else {
        this.$v.$reset();
        this.user = "";
        this.customer = "";
      }
    }
  }
};
</script>
